<div class="d-flex flex-column min-vh-100 bg-dark">
  <!-- Gridster scrollable area -->
  <div class="gridster-wrapper flex-grow-1 overflow-auto" style="height: calc(100vh - 80px);">
    <gridster [options]="options">
      @for (item of dashboard; track item) {
      <gridster-item [item]="item">
        <!-- TaxAmount -->
        @if (item.hasContent && item.contentType === 'TaxAmount') {
        <div class="gridster-item-content d-flex justify-content-center align-items-center">
          <div class="drag-handler card-body w-100">
            <div class="row align-items-center h-100">
              <div class="col-sm-10">
                <ngx-charts-bar-vertical-stacked [scheme]="colorScheme" [results]="single" [gradient]="gradient"
                  [xAxis]="showXAxis" [yAxis]="showYAxis" [legend]="showLegend" [showXAxisLabel]="showXAxisLabel"
                  [showYAxisLabel]="showYAxisLabel" [xAxisLabel]="xAxisLabel" [yAxisLabel]="yAxisLabel"
                  [animations]="animations" [showDataLabel]="showDataLabel">
                </ngx-charts-bar-vertical-stacked>
              </div>
              <div class="col-sm-2 d-flex flex-column align-items-center justify-content-center h-100">
                @for (val of ['Today', 'Week', 'Month']; track val; let label = $index) {
                @if (AtpData[val] === '') {
                <div class="count-numbers" id="wave">
                  <span class="dot"></span>
                  <span class="dot"></span>
                  <span class="dot"></span>
                </div>
                }
                @if (AtpData[val] !== null && AtpData[val] !== '') {
                <h1>{{AtpData[val] | number: '1.0-2':'nl'}}</h1>
                }
                <h4>
                  {{ ['Taxaties vandaag', 'Taxaties afgelopen 7 dagen', 'Taxaties afgelopen 31 dagen'][label] }}
                </h4>
                <br />
                }
              </div>
            </div>
          </div>
        </div>
        }
        <!-- CarCounter -->
        @if (item.hasContent && item.contentType === 'CarCounter') {
        <div class="gridster-item-content">
          <div class="drag-handler card-body">
            <div class="row">
              <div class="col-12">
                <table class="table table-dark text-white w-100">
                  <tbody>
                    @for (item of AtpData.BuyData.weeks; track $index) {
                    <tr>
                      @for (key of ['za', 'ma', 'di', 'woe', 'do', 'vr']; track key) {
                      @if (item.days[key] !== 0) {
                      <td>{{item.days[key]}}</td>
                      }
                      @if (item.days[key] === 0) {
                      <td></td>
                      }
                      }
                      <td>{{item.days.za + item.days.ma + item.days.di + item.days.woe + item.days.do + item.days.vr}}
                      </td>
                    </tr>
                    }
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        }
        <!-- CarAmount -->
        @if (item.hasContent && item.contentType === 'CarAmount') {
        <div class="gridster-item-content p-3">
          <div class="drag-handler card-body w-100 h-100 d-flex flex-column">
            <h4 class="card-title">ATP Statistieken</h4>
            <hr class="hr-light w-100" />
            <div class="row w-100">
              @for (key of ['Buy', 'CurrentRemaining', 'Remaining', 'YearTarget']; track key; let i = $index) {
              <div class="col-md-6">
                <div class="card-counter primary">
                  <i class="fas fa-car"></i>
                  <div class="card-counter-content">
                    @if (AtpData[key] === '') {
                    <div class="count-numbers" id="wave">
                      <span class="dot"></span>
                      <span class="dot"></span>
                      <span class="dot"></span>
                    </div>
                    }
                    @if (AtpData[key] !== '') {
                    <div class="count-numbers">
                      {{ AtpData[key] }}
                    </div>
                    }
                    <div class="count-name">
                      {{ ['Voertuigen te koop', 'Taxaties in biedtermijn', 'Nog te taxeren', ''][i] }}
                    </div>
                  </div>
                </div>
              </div>
              }
            </div>
          </div>
        </div>
        }
        <!-- AVP -->
        @if (item.hasContent && item.contentType === 'AVP') {
        <div class="gridster-item-content d-flex p-3">
          <div class="drag-handler card-body w-100 h-100 d-flex flex-column">
            <h4 class="card-title">AVP Statistieken</h4>
            <hr class="hr-light w-100" />
            <div class="row w-100">
              @for (item of avpCards; track item.key) {
              <div class="col-md-6">
                <div class="card-counter secondary d-flex align-items-center p-3">
                  <i class="fas fa-car me-3" style="font-size: 2.5em;"></i>
                  <div class="d-flex flex-column align-items-end w-100">
                    @if (item.value === '') {
                    <div class="count-numbers" id="wave">
                      <span class="dot"></span><span class="dot"></span><span class="dot"></span>
                    </div>
                    }
                    @if (item.value !== '') {
                    <div class="count-numbers">
                      {{ item.value }}@if (item.key === 'ConversionWeek' && item.value !== '') {
                      <span>%</span>
                      }
                    </div>
                    }
                    <div class="count-name text-end">{{ item.label }}</div>
                  </div>
                </div>
              </div>
              }
            </div>
          </div>
        </div>
        }
        <!-- AVP-details -->
        @if (item.hasContent && item.contentType === 'AVP-details') {
        <div class="gridster-item-content p-4">
          <div class="row">
            <div class="drag-handler card-body">
              <ngx-charts-bar-vertical-stacked [scheme]="avpColorScheme" [results]="AvpBarChartData"
                [gradient]="gradient" [xAxis]="showXAxis" [yAxis]="showYAxis" [legend]="showLegend"
                [showXAxisLabel]="showXAxisLabel" [showYAxisLabel]="showYAxisLabel" [xAxisLabel]="xAxisLabel"
                yAxisLabel="Aantal AVP taxaties" [view]="[850,300]" [animations]="animations"
                [showDataLabel]="showDataLabel">
              </ngx-charts-bar-vertical-stacked>
            </div>
          </div>
        </div>
        }
        <!-- Conversions -->
        @if (item.hasContent && item.contentType === 'Conversions') {
        <div class="gridster-item-content p-2">
          <div class="drag-handler card-body">
            <div class="row">
              <div class="col-sm-12">
                <table class="table table-dark text-white clickable-table">
                  <thead>
                    <tr>
                      <th>Dag</th>
                      <th>GM</th>
                      <th>TOT-T</th>
                      <th>TOT-M</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (item of AtpData.Conversions; track $index; let i = $index) {
                    <tr (click)="openMarginModal(item.date)" class="clickable-row" [class.has-data]="item.total_valuations > 0">
                      <td>{{daysOfWeek[i]}}</td>
                      <td>{{item.avg_margin | number: '1.0-0'}}</td>
                      <td>{{item.total_valuations}}</td>
                      <td>{{item.total_margin}}</td>
                    </tr>
                    }
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        }
      </gridster-item>
      }
    </gridster>
  </div>

  <!-- Footer stays at bottom -->
  <footer class="page-footer">
    <div class="text-center py-2 small text-light">
      <div class="d-flex justify-content-center align-items-center gap-4">
        <div>
          <i class="Blink fa fa-circle text-danger"></i>&nbsp; LIVE - {{ currentTime | date:'HH:mm:ss'}} Versie: {{
          version }}
        </div>
        <div>
          <button class="btn btn-sm btn-outline-light" (click)="logout()">
            <i class="fas fa-sign-out-alt me-1"></i>Uitloggen
          </button>
        </div>
      </div>
    </div>
  </footer>
</div>

<!-- Margin Details Modal -->
<app-margin-details-modal #marginModal></app-margin-details-modal>